module.exports = __webpack_public_path__ + "img/LUB00316.516a0209.png";